export default __webpack_public_path__ + "rs.jpg?72d08172937a768904334fa20470d9df";